<template>
    <section>
        <section id="firebaseui-auth-container"></section>
    </section>
</template>

<script>
import firebase from "firebase";
import * as firebaseui from "firebaseui"
import "firebaseui/dist/firebaseui.css";

export default {
    data() {
        return {
        };
    },
    components: {
    },
    mounted() 
    {
        this.$emit('navigation_drawer', true);

        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        var uiConfig = {
            signInSuccessUrl: "/home", // This redirect can be achived by route using callback.
            signInFlow: "popup",
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ]
        };
        ui.start("#firebaseui-auth-container", uiConfig);
    }
};
</script>

<style scoped>
</style>
